import {Tooltip} from "antd";
import styles from "./Attribute.module.css";

export const Attribute = ({attr, onRequestAttr}) => {
	const {value, substring: from, matched, match, score} = attr;

	function handleClick() {
		onRequestAttr({text: value, hash: Date.now()});
	}

	const displayedValue =
		"substring" in attr ? (
			<>
				{value.slice(0, from)}
				<strong key="match">{value.slice(from, from + matched.value.length)}</strong>
				{value.slice(from + matched.value.length)}
			</>
		) : (
			value
		);

	const isMatched = match !== "none";

	if (!isMatched) {
		return (
			<span className={styles.Attr} onClick={handleClick}>
				{displayedValue}
			</span>
		);
	}

	const attrClass = [styles.Attr, isMatched ? styles["Attr-matched"] : "", isMatched ? styles[`Attr-${match}`] : ""]
		.filter(Boolean)
		.join(" ");

	const tooltipContent = `${score.toFixed(2)}: ${matched.value}`;

	return (
		<Tooltip id={matched.value} title={tooltipContent} placement="top" mouseEnterDelay={0.3} mouseLeaveDelay={0.15}>
			<span className={attrClass} onClick={handleClick}>
				{displayedValue}
			</span>
		</Tooltip>
	);
};
